import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './SignIn.css';

function SignIn() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [resetSent, setResetSent] = useState(false);

    const handleSignIn = async () => {
        setError('');

        if (!email || !password) {
            setError('Please enter your email and password.');
            return;
        }

        setLoading(true);

        try {
            const { error: signInError } = await supabase.auth.signInWithPassword({
                email,
                password,
            });

            if (signInError) {
                setError('Incorrect email or password. Please try again.');
                setLoading(false);
                return;
            }

            navigate('/home');

        } catch (err) {
            setError('Something went wrong. Please try again.');
        }

        setLoading(false);
    };

    const handleForgotPassword = async () => {
        if (!email) {
            setError('Please enter your email address first.');
            return;
        }

        const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: 'https://vozoly.vercel.app/reset-password',
        });

        if (resetError) {
            setError(resetError.message);
        } else {
            setResetSent(true);
            setError('');
        }
    };

    return (
        <div className="si-screen">

            <div className="si-top">
                <button className="si-back" onClick={() => navigate('/')}>←</button>
            </div>

            <div className="si-content">

                <div className="si-logo">
                    <svg width="52" height="52" viewBox="0 0 72 72" fill="none">
                        <rect width="72" height="72" rx="18" fill="#085041" />
                        <path d="M10 36C10 36 17 14 26 14C35 14 35 58 44 58C53 58 60 36 60 36" stroke="#9FE1CB" strokeWidth="3.5" strokeLinecap="round" />
                        <path d="M10 36C10 36 17 24 26 24C35 24 35 48 44 48C53 48 60 36 60 36" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.35" />
                    </svg>
                </div>

                <div className="si-heading">Welcome back</div>
                <div className="si-subheading">Sign in to continue your learning journey</div>

                <div className="si-form">

                    <div className="si-field">
                        <div className="si-label">Email address</div>
                        <input
                            className="si-input"
                            type="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            autoCapitalize="none"
                        />
                    </div>

                    <div className="si-field">
                        <div className="si-label-row">
                            <div className="si-label">Password</div>
                            <button className="si-forgot" onClick={handleForgotPassword}>
                                Forgot password?
                            </button>
                        </div>
                        <div className="si-input-wrap">
                            <input
                                className="si-input si-input-pw"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Your password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <button
                                className="si-show-pw"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="si-error">⚠️ {error}</div>
                    )}

                    {resetSent && (
                        <div className="si-success">
                            ✓ Password reset email sent — check your inbox.
                        </div>
                    )}

                    <button
                        className="si-btn-primary"
                        onClick={handleSignIn}
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign in →'}
                    </button>

                    <div className="si-divider">
                        <div className="si-divider-line"></div>
                        <div className="si-divider-text">or</div>
                        <div className="si-divider-line"></div>
                    </div>

                    <button className="si-btn-google" disabled>
                        <span className="si-google-icon">G</span>
                        Continue with Google
                        <span className="si-coming-soon">Coming soon</span>
                    </button>

                </div>

                <div className="si-signup-link">
                    Don't have an account?{' '}
                    <span className="si-signup-btn" onClick={() => navigate('/signup')}>
                        Create one free
                    </span>
                </div>

            </div>

        </div>
    );
}

export default SignIn;